import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { Button } from "@jti/core-components/components/Button";

import styles from "./DatePickerFooter.module.scss";

interface DatePickerFooterProps {
  onSaveSelection: (selectedDate: Date | null) => void;
  selected: Date | null;
}

export const DatePickerFooter: React.FC<DatePickerFooterProps> = ({ onSaveSelection, selected }) => {
  const { __ } = useTranslations();
  const handleSaveSelectionButtonClick = () => {
    onSaveSelection(selected);
  };

  return (
    <div className={styles.container}>
      <div className={styles.legendBox}>
        <ul className={styles.legendList}>
          <li className={classNames(styles.legendListElement, styles.legendCurrentDate)}>
            <span className={styles.legendColorBox}></span>
            {__("daypicker.current_billing_date")}
          </li>
          <li className={classNames(styles.legendListElement, styles.legendNewDate)}>
            <span className={styles.legendColorBox}></span>
            {__("daypicker.new_billing_date")}
          </li>
        </ul>
      </div>
      <div className={styles.buttonBox}>
        <Button
          variant="secondary"
          size="md"
          className={styles.button}
          onClick={handleSaveSelectionButtonClick}
          disabled={!selected}
        >
          {__("daypicker.save_selection")}
        </Button>
      </div>
    </div>
  );
};
